import React from 'react';

/**
 * Renders a `ts_headline` snippet, marking the matched terms.
 *
 * Postgres emits the match delimited by `<<` and `>>` rather than HTML. The
 * delimiters are sentinels, not markup, so the passage can be split into elements
 * instead of injected as HTML — snippets are user-authored document text, and
 * rendering them as HTML would make stored XSS a search feature.
 */
const DELIMITED = /<<(.*?)>>/gs;

export const SnippetText: React.FC<{ snippet: string; className?: string }> = ({
  snippet,
  className,
}) => {
  const parts: React.ReactNode[] = [];
  let cursor = 0;

  for (const match of snippet.matchAll(DELIMITED)) {
    const start = match.index ?? 0;
    if (start > cursor) parts.push(snippet.slice(cursor, start));
    parts.push(<mark key={start}>{match[1]}</mark>);
    cursor = start + match[0].length;
  }
  if (cursor < snippet.length) parts.push(snippet.slice(cursor));

  return <span className={className}>{parts}</span>;
};
